<template lang="html">
  <div class="related-content">
    <RelatedContentTile
      v-for="item in randomItems"
      :key="item.id"
      :background="item.columns.teaser.media.path"
    >
      Entdecken Sie auch:
      <nuxt-link v-if="getUrl(item)" :to="getUrl(item)">
        <Headline color="white">
          <span
            v-html="item.columns.title"
          />
        </Headline>
      </nuxt-link>
    </RelatedContentTile>
  </div>
</template>

<script>
import { Resource } from 'beisheim/models'
import { sampleSize } from 'lodash'
import Headline from 'beisheim/components/elements/headline'
import RelatedContentTile from 'beisheim/components/elements/related-content-tile'

export default {
  components: {
    Headline,
    RelatedContentTile
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    randomItems () {
      return sampleSize(this.items, 2)
    }
  },
  methods: {
    getUrl (item) {
      if (!item) { return }
      if (item.url) { return item.url }
      const link = Resource.find(item.columns.link_name)
      return link ? link.url : null
    }
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/grid';
@import '~beisheim/scss/breakpoints';

$component: '.related-content';

#{$component} {
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  @include from(4) {
    flex-direction: row;
  }
}
</style>
